import 'css-chunksrc/client/common/layout/projectHistory/history/styles.scss';export default {
  "history": "_history_1dy9m_1",
  "item": "_item_1dy9m_6",
  "icon": "_icon_1dy9m_19"
};